import React, { useRef } from "react";
import Meta from "../lib/Meta";
import Id from "./EventLogin/Id";
import LoginButton from "./EventLogin/LoginButton";
import Password from "./EventLogin/Password";

function EventLogin(props) {
  console.log(props);
  const idRef = useRef(null);
  const funct = (e) => {
    console.log(e + "log예용");
  };
  const metaData = {
    image: "%PUBLIC_URL%/logo192.png",
    title: "로그인 화면",
    description: "로그인 화면입니다.",
    width: 192,
    height: 192,
    canonical: `event`,
  };
  return (
    <div>
      <Meta data={metaData} />
      <Id id="aa" idRef={idRef} onChangeId={funct}></Id>
      <Password password="aa" onChnagePassword={funct}></Password>
      <LoginButton />
    </div>
  );
}
export default EventLogin;
